import { useState, useEffect } from 'react';
import { profile } from '../data/profile';
import { DownloadIcon } from './icons';
import './Nav.css';

const LINKS = [
  { id: 'hero', label: 'Home' },
  { id: 'about', label: 'About' },
  { id: 'skills', label: 'Skills' },
  { id: 'projects', label: 'Projects' },
  { id: 'footer', label: 'Contact' },
];

export function Nav({ activeSection, onNavigate }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    onNavigate(id);
  };

  return (
    <header className={`nav-bar ${scrolled ? 'scrolled' : ''}`}>
      <div className="nav-inner">
        <button className="logo" onClick={() => go('hero')}>
          Habeeb<span>.</span>
        </button>

        <nav className={`nav-links ${open ? 'open' : ''}`} aria-label="Primary">
          {LINKS.map((l) => (
            <button
              key={l.id}
              className={`nav-item ${activeSection === l.id ? 'active' : ''}`}
              onClick={() => go(l.id)}
            >
              {l.label}
            </button>
          ))}
          <a
            className="nav-resume mobile-only"
            href={profile.socials.resume}
            target="_blank"
            rel="noopener noreferrer"
          >
            <DownloadIcon /> Résumé
          </a>
        </nav>

        <a
          className="nav-resume desktop-only"
          href={profile.socials.resume}
          target="_blank"
          rel="noopener noreferrer"
        >
          <DownloadIcon /> Résumé
        </a>

        <button
          className={`hamburger ${open ? 'open' : ''}`}
          onClick={() => setOpen((o) => !o)}
          aria-label="Toggle navigation menu"
          aria-expanded={open}
        >
          <span />
          <span />
          <span />
        </button>
      </div>
    </header>
  );
}
